// FAQ module
// Converts {{faq: Title}} ... {{/faq}} to a styled FAQ section.
// Toggle blocks inside are processed via the recurse callback.

/**
 * @param {Element}  container
 * @param {Map}      footnotesMap
 * @param {Function} recurse  - processAllSnippets(container, footnotesMap)
 */
export function processFaqBlocks(container, footnotesMap, recurse) {
  const allElements = Array.from(container.children);
  const startRegex  = /\{\{faq:\s*([^}]+)\}\}/;
  const endRegex    = /\{\{\/faq\}\}/;

  const blocks = [];

  for (let i = 0; i < allElements.length; i++) {
    const element = allElements[i];
    const startMatch = (element.textContent || '').match(startRegex);
    if (!startMatch) continue;

    const title = startMatch[1].trim();
    let endIndex = -1, endElement = null;

    for (let j = i + 1; j < allElements.length; j++) {
      if ((allElements[j].textContent || '').match(endRegex)) {
        endIndex = j; endElement = allElements[j]; break;
      }
    }

    if (endIndex === -1) {
      console.warn(`[FAQ] "{{faq: ${title}}}" has no closing {{/faq}}.`);
      continue;
    }

    blocks.push({ startIndex: i, endIndex, startElement: element, endElement, title });
    i = endIndex;
  }

  // Process in reverse order to keep indices stable
  blocks.reverse().forEach(block => {
    if (!block.startElement?.parentNode || !block.endElement?.parentNode) return;

    const faqDiv = document.createElement('div');
    faqDiv.className = 'faq';

    if (block.title) {
      const titleEl = document.createElement('h2');
      titleEl.className = 'faq__title';
      titleEl.textContent = block.title;
      faqDiv.appendChild(titleEl);
    }

    const itemsDiv = document.createElement('div');
    itemsDiv.className = 'faq__items';
    faqDiv.appendChild(itemsDiv);

    // Collect element references first, then move them (avoid live NodeList issues)
    const currentChildren = Array.from(container.children);
    const toMove = [];
    for (let k = block.startIndex + 1; k < block.endIndex && k < currentChildren.length; k++) {
      const mid = currentChildren[k];
      if (mid && mid !== block.startElement && mid !== block.endElement) {
        toMove.push(mid);
      }
    }
    // Moving elements (not cloning) — appendChild automatically detaches from container
    toMove.forEach(el => itemsDiv.appendChild(el));

    // Replace start marker with the FAQ div, remove end marker
    block.startElement.replaceWith(faqDiv);
    block.endElement?.parentNode?.removeChild(block.endElement);

    // Process nested snippets (toggles etc.) inside the FAQ items
    if (recurse) recurse(itemsDiv, footnotesMap);
  });
}
